// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as SignRouteRouteImport } from './routes/sign/route'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as MarketingChangelogRouteImport } from './routes/_marketing/changelog'
import { Route as MarketingContactRouteImport } from './routes/_marketing/contact'
import { Route as MarketingCookiesRouteImport } from './routes/_marketing/cookies'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing/privacy'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAdminRouteRouteImport } from './routes/app/admin/route'
import { Route as AppChatRouteImport } from './routes/app/chat'
import { Route as AppNotesRouteImport } from './routes/app/notes'
import { Route as AppOrganizationRouteImport } from './routes/app/organization'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppTasksRouteImport } from './routes/app/tasks'
import { Route as AppWebhooksRouteImport } from './routes/app/webhooks'
import { Route as InviteIdRouteImport } from './routes/invite/$id'
import { Route as MailUnsubscribeRouteImport } from './routes/mail/unsubscribe'
import { Route as OrgsNewRouteImport } from './routes/orgs/new'
import { Route as Sign2faRouteImport } from './routes/sign/2fa'
import { Route as SignForgotRouteImport } from './routes/sign/forgot'
import { Route as SignInRouteImport } from './routes/sign/in'
import { Route as SignLinkRouteImport } from './routes/sign/link'
import { Route as SignResetRouteImport } from './routes/sign/reset'
import { Route as SignUpRouteImport } from './routes/sign/up'
import { Route as MarketingBlogIndexRouteImport } from './routes/_marketing/blog.index'
import { Route as MarketingBlogSlugRouteImport } from './routes/_marketing/blog.$slug'
import { Route as AppAdminIndexRouteImport } from './routes/app/admin/index'
import { Route as AppAdminOrganizationsRouteImport } from './routes/app/admin/organizations'
import { Route as AppAdminUsersRouteImport } from './routes/app/admin/users'

const MarketingRoute = MarketingRouteImport.update({
            id: '/_marketing',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const DeviceRoute = DeviceRouteImport.update({
            id: '/device',path: '/device',getParentRoute: () => rootRouteImport
          })
const SignRouteRoute = SignRouteRouteImport.update({
            id: '/sign',path: '/sign',getParentRoute: () => rootRouteImport
          })
const MarketingIndexRoute = MarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingRoute
          })
const MarketingChangelogRoute = MarketingChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => MarketingRoute
          })
const MarketingContactRoute = MarketingContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => MarketingRoute
          })
const MarketingCookiesRoute = MarketingCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => MarketingRoute
          })
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => MarketingRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRouteRoute
          })
const AppChatRoute = AppChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AppRouteRoute
          })
const AppNotesRoute = AppNotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationRoute = AppOrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => AppRouteRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRouteRoute
          })
const AppTasksRoute = AppTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AppRouteRoute
          })
const AppWebhooksRoute = AppWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => AppRouteRoute
          })
const InviteIdRoute = InviteIdRouteImport.update({
            id: '/invite/$id',path: '/invite/$id',getParentRoute: () => rootRouteImport
          })
const MailUnsubscribeRoute = MailUnsubscribeRouteImport.update({
            id: '/mail/unsubscribe',path: '/mail/unsubscribe',getParentRoute: () => rootRouteImport
          })
const OrgsNewRoute = OrgsNewRouteImport.update({
            id: '/orgs/new',path: '/orgs/new',getParentRoute: () => rootRouteImport
          })
const Sign2faRoute = Sign2faRouteImport.update({
            id: '/2fa',path: '/2fa',getParentRoute: () => SignRouteRoute
          })
const SignForgotRoute = SignForgotRouteImport.update({
            id: '/forgot',path: '/forgot',getParentRoute: () => SignRouteRoute
          })
const SignInRoute = SignInRouteImport.update({
            id: '/in',path: '/in',getParentRoute: () => SignRouteRoute
          })
const SignLinkRoute = SignLinkRouteImport.update({
            id: '/link',path: '/link',getParentRoute: () => SignRouteRoute
          })
const SignResetRoute = SignResetRouteImport.update({
            id: '/reset',path: '/reset',getParentRoute: () => SignRouteRoute
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/up',path: '/up',getParentRoute: () => SignRouteRoute
          })
const MarketingBlogIndexRoute = MarketingBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => MarketingRoute
          })
const MarketingBlogSlugRoute = MarketingBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => MarketingRoute
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminOrganizationsRoute = AppAdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppAdminRouteRoute
          })





const AppAdminRouteRouteChildren = {
  AppAdminOrganizationsRoute: AppAdminOrganizationsRoute,AppAdminUsersRoute: AppAdminUsersRoute,AppAdminIndexRoute: AppAdminIndexRoute
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(AppAdminRouteRouteChildren)



const AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,AppChatRoute: AppChatRoute,AppNotesRoute: AppNotesRoute,AppOrganizationRoute: AppOrganizationRoute,AppSettingsRoute: AppSettingsRoute,AppTasksRoute: AppTasksRoute,AppWebhooksRoute: AppWebhooksRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const SignRouteRouteChildren = {
  Sign2faRoute: Sign2faRoute,SignForgotRoute: SignForgotRoute,SignInRoute: SignInRoute,SignLinkRoute: SignLinkRoute,SignResetRoute: SignResetRoute,SignUpRoute: SignUpRoute
}

const SignRouteRouteWithChildren = SignRouteRoute._addFileChildren(SignRouteRouteChildren)




const MarketingRouteChildren = {
  MarketingChangelogRoute: MarketingChangelogRoute,MarketingContactRoute: MarketingContactRoute,MarketingCookiesRoute: MarketingCookiesRoute,MarketingPrivacyRoute: MarketingPrivacyRoute,MarketingIndexRoute: MarketingIndexRoute,MarketingBlogSlugRoute: MarketingBlogSlugRoute,MarketingBlogIndexRoute: MarketingBlogIndexRoute
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(MarketingRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,SignRouteRoute: SignRouteRouteWithChildren,MarketingRoute: MarketingRouteWithChildren,DeviceRoute: DeviceRoute,InviteIdRoute: InviteIdRoute,MailUnsubscribeRoute: MailUnsubscribeRoute,OrgsNewRoute: OrgsNewRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)